import React, { useState } from 'react';
import { demoService } from '../services/apiClient';
import { FaCheckCircle } from 'react-icons/fa';
import SectionTitle from './common/SectionTitle';


const RequestDemo = () => {
  const [formData, setFormData] = useState({
    to:'hello@sellwise360.com',
    name: '',
    email: '',
    phone: '',
    company: '',
    companySize: '',
    industry: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  
  // Validation regex patterns
  const phoneRegex = /^[\d\s+.,]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };
const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.phone) {
      newErrors.phone = 'Phone number is required';
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Phone number can only contain numbers, +, ., , and spaces';
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Company name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      await demoService.submitDemoRequest(formData);
      setIsSubmitted(true);
      setFormData({
        to:'hello@sellwise360.com',
        name: '',
        email: '',
        phone: '',
        company: '',
        companySize: '',
        industry: '',
        message: ''
      });
    } catch (err) {
      setErrors({ submit: err instanceof Error ? err.message : 'An error occurred' });
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
           <section className="demo" id="demo">
  <div className="container">
    <div className="demo-content">
      <SectionTitle
        title="Request a Demo"
        subtitle="See how SellWise can transform your FMCG distribution business."
      />
      
      <div className="success-container">
        <div className="success-message">
          <div className="success-icon">
            <FaCheckCircle />
          </div>
          <h3>Thank You!</h3>
          <p>Your demo request has been received. Our team will contact you within 24 hours.</p>
          <button
            onClick={() => setIsSubmitted(false)}
            className="cta-button"
          >
            Request Another Demo
          </button>
        </div>
      </div>
    </div>
  </div>

  <style jsx>{`
    .demo {
      padding: 80px 0;
      min-height: 60vh;
      display: flex;
      align-items: center;
    }
    
    .demo-content {
      text-align: center;
    }
    
    .success-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 400px;
      margin-top: 40px;
    }
    
    .success-message {
      background: white;
      padding: 50px 40px;
      border-radius: 20px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
      text-align: center;
      max-width: 500px;
      width: 100%;
      border: 2px solid #FFD700;
    }
    
    .success-icon {
      font-size: 64px;
      color: #28a745;
      margin-bottom: 25px;
    }
    
    .success-message h3 {
      color: #212121;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    
    .success-message p {
      color: #666;
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 30px;
    }
    
    .cta-button {
      background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
      color: white;
      padding: 15px 35px;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);
    }
    
    .cta-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 140, 0, 0.4);
    }
    
    .cta-button:active {
      transform: translateY(0);
    }
    
    @media (max-width: 768px) {
      .demo {
        padding: 60px 0;
      }
      
      .success-message {
        padding: 40px 30px;
        margin: 0 20px;
      }
      
      .success-icon {
        font-size: 48px;
      }
      
      .success-message h3 {
        font-size: 24px;
      }
    }
    
    @media (max-width: 480px) {
      .success-message {
        padding: 30px 20px;
      }
      
      .success-icon {
        font-size: 40px;
        margin-bottom: 20px;
      }
      
      .success-message h3 {
        font-size: 22px;
      }
      
      .success-message p {
        font-size: 14px;
      }
      
      .cta-button {
        padding: 12px 25px;
        font-size: 14px;
      }
    }
  `}</style>
</section>
    );
  }

  return (
        <section className="demo" id="demo">

    <div className="container">
<br/><br/>
        <SectionTitle
          title="Request a Demo"
          subtitle="See how SellWise can transform your FMCG distribution business."
        />

        {errors.submit && (
                  <div className="error-message">
                    {errors.submit}
                  </div>
                )}

       <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">
              Full Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              className={errors.name ? 'error' : ''}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">
              Email Address *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">
              Phone Number *
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              required
              value={formData.phone}
              onChange={handleChange}
              placeholder="+234 000 000 0000"
              className={errors.phone ? 'error' : ''}
            />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="company">
              Company Name *
            </label>
            <input
              type="text"
              id="company"
              name="company"
              required
              value={formData.company}
              onChange={handleChange}
              placeholder="Your company name"
              className={errors.company ? 'error' : ''}
            />
            {errors.company && <span className="error-text">{errors.company}</span>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="companySize">
              Company Size
            </label>
            <select
              id="companySize"
              name="companySize"
              value={formData.companySize}
              onChange={handleChange}
            >
              <option value="">Select size</option>
              <option value="1-10">1-10 employees</option>
              <option value="11-50">11-50 employees</option>
              <option value="51-200">51-200 employees</option>
              <option value="201-500">201-500 employees</option>
              <option value="501+">501+ employees</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="industry">
              Industry
            </label>
            <select
              id="industry"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
            >
              <option value="">Select industry</option>
              <option value="fmcg">FMCG Distribution</option>
              <option value="food-beverage">Food & Beverage</option>
              <option value="retail">Retail</option>
              <option value="logistics">Logistics</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message">
            Additional Message
          </label>
          <textarea
            id="message"
            name="message"
            rows={4}
            value={formData.message}
            onChange={handleChange}
            placeholder="Tell us about your distribution needs..."
          />
        </div>

       <button
          type="submit"
          disabled={isLoading}
          className="cta-button"
        >
          {isLoading ? 'Submitting...' : 'Request Demo'}
        </button>
      </form>
      <br /><br />
      <style jsx>{`
        .demo-form {
          background: white;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        .demo-form h2 {
          color: #212121;
          font-size: 28px;
          margin-bottom: 10px;
        }
        
        .demo-subtitle {
          color: #666;
          margin-bottom: 30px;
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          font-weight: 600;
          color: #212121;
          margin-bottom: 8px;
        }
        
        .form-group input,
        .form-group select,
        .form-group textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 16px;
        }
        
        .form-group textarea {
          height: 120px;
          resize: vertical;
        }
        
        .success-message {
          text-align: center;
          padding: 40px 20px;
          background: white;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        .success-icon {
          font-size: 50px;
          color: #28a745;
          margin-bottom: 20px;
        }
        
        .success-message h3 {
          color: #212121;
          margin-bottom: 10px;
        }
        
        .success-message p {
          color: #666;
          margin-bottom: 20px;
        }
        
        .error-message {
          background-color: #ffebee;
          color: #c62828;
          padding: 15px;
          border-radius: 5px;
          margin-bottom: 20px;
          border: 1px solid #ffcdd2;
        }
        
        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
    </section>
  );
};

export default RequestDemo;